if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.boundArrowClick = this.handleArrowClick.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();

        // Capture phase so the arrows still work if another handler stops propagation.
        this.removeEventListener("click", this.boundArrowClick, true);
        this.addEventListener("click", this.boundArrowClick, true);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaList() {
        const container = this.querySelector('[role="document"]');
        if (!container) return [];

        // Only direct media elements count as slides. Variant images hidden by the
        // "hide other variants' media" setting are skipped, except the current
        // variant's featured media, which is always rendered first.
        return Array.from(container.children).filter(
          (element) =>
            element.hasAttribute("data-media-id") &&
            (!element.classList.contains("product__media-item--variant") ||
              element === container.firstElementChild),
        );
      }

      handleArrowClick(event) {
        const button = event.target.closest(
          ".product-media-modal__nav--prev, .product-media-modal__nav--next",
        );
        if (!button || !this.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const step = button.classList.contains("product-media-modal__nav--prev")
          ? -1
          : 1;
        this.navigateMedia(step);
      }

      navigateMedia(step) {
        const mediaList = this.getMediaList();
        if (mediaList.length < 2) return;

        let currentIndex = mediaList.findIndex((element) =>
          element.classList.contains("active"),
        );
        if (currentIndex === -1) currentIndex = 0;

        const nextIndex =
          (currentIndex + step + mediaList.length) % mediaList.length;
        this.activateMedia(mediaList[nextIndex]);
      }

      activateMedia(activeMedia) {
        if (!activeMedia) return;

        this.querySelectorAll("[data-media-id].active").forEach((element) => {
          if (element !== activeMedia) element.classList.remove("active");
        });
        activeMedia.classList.add("active");

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollTop = 0;

        window.pauseAllMedia();

        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        if (
          activeMedia.nodeName === "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        ) {
          activeMedia.loadContent();
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute("data-media-id");
        const activeMedia =
          (mediaId &&
            this.querySelector(
              `[role="document"] > [data-media-id="${mediaId}"]`,
            )) ||
          this.getMediaList()[0];
        this.activateMedia(activeMedia);
      }
    },
  );
}
